<template>
    <div>
        <el-descriptions class="margin-top" title="" direction="vertical" :column="3" border>
            <el-descriptions-item>
                <template slot="label">活动名称 </template> {{ rowObj.name }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">巡查日期 </template> {{ rowObj.check_date }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">巡查对象</template> {{ rowObj.target_name }}
            </el-descriptions-item>
            <el-descriptions-item :span="3">
                <template slot="label">巡查内容 </template> {{ rowObj.content ? rowObj.content : '' }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">巡查人员 </template> {{ rowObj.member_names }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">巡查结果 </template> {{ rowObj.check_result_text }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">上报人员 </template> {{ rowObj.submit_name }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">上报时间 </template> {{ rowObj.submit_time }}
            </el-descriptions-item>
        </el-descriptions>
        <template v-if="rowObj.hazards && rowObj.hazards.length > 0">
            <p style="font-size: 16px;font-weight: 700;color:#111;margin-top:32px;margin-bottom:20px; padding:0 12px;">隐患列表</p>
            <el-descriptions class="margin-top" title="" style="margin-bottom:16px;"
                v-for="(item, index) in rowObj.hazards" :key="index" direction="vertical" :column="2" border>
                <el-descriptions-item>
                    <template slot="label">整改对象 </template> {{ item.target_name }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">隐患等级 </template> {{ item.hazard_level_text }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">限定整改日期 </template> {{ item.rectification_limit_date }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">整改状态 </template> {{ item.rectification_status_text }}
                </el-descriptions-item>
                <el-descriptions-item :span="3">
                    <template slot="label">隐患描述 </template> {{ item.description }}
                </el-descriptions-item>
                <el-descriptions-item :span="3">
                    <template slot="label">隐患图片 </template>
                    <div v-if="item.image">
                        <el-image v-for="(img, index) in item.image.split(',')" :key="index"
                            style="width: 100px; height: 100px" :src="img" :preview-src-list="item.image.split(',')">
                        </el-image>
                    </div>
                    <span v-else>无</span>
                </el-descriptions-item>
            </el-descriptions>
        </template>
    </div>
</template>
<script>
export default {
    props: ['rowObj'],
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>
